.tag {
  @include font(aux, xxxs, 600);
  padding-inline: spacing(8);
  border-radius: radius(xxs);
  align-content: center;
  text-transform: uppercase;

  &.inline {
    display: inline-flex;
  }

  &.large {
    min-height: spacing(24);
  }
}

.success {
  background-color: c(success01);
  color: c(success04);
}

.warning {
  background-color: c(warning01);
  color: c(warning04);
}

.negative {
  background-color: c(error01);
  color: c(error04);
}
